var mp = mp || {};

// Toogle Menu
//-----------------------------------------------------------------
mp.MenuToggle = function() {
	var $toggleButton = $('.header--hamburger');
    var $drawerWraper = $('.header .menu');

    if (!$toggleButton.length) {
        return;
    }
    
    $toggleButton.on('touchstart click', function(e) {
        e.preventDefault();
        
        $drawerWraper.toggleClass('is_open');
        $(this).toggleClass('is_open');
        $('body').toggleClass('locked');
    });

    setMobileMenuHeight();
}


// Set Mobile Menu Height
//-----------------------------------------------------------------
function setMobileMenuHeight(){
    var $toggleButton = $('.header--hamburger');
    var $drawerWraper = $('.header .menu');   
    
    var _vph = $(window).height();
    var _vpw = $(window).width();

    if (_vpw < 1024) {
        $drawerWraper.css('height', _vph - 80);
    } else {
        $drawerWraper.removeClass('is_open').removeAttr('style');
        $toggleButton.removeClass('is_open');
        $('body').removeClass('locked');
    }
}



$(document).ready(function(){
    mp.MenuToggle();
});